import React, { ReactElement } from 'react';
import Select from 'react-select';
import { SelectedKrets, selectKretsAction } from '../../../../catalog/krets-actions';
import { decorateOrganizer, kretsSorter } from '../../../../utils';
import { RemoteOrganizer } from '../../../../types';
import { useDispatch, useSelector } from 'react-redux';

interface KretsProps {
  organizers?: RemoteOrganizer[];
}

const excludedTypes = ['Nämnd', 'Riksförening'];

export default function Krets(props: KretsProps): ReactElement {
  const { selected } = useSelector((state: { selectedKrets: SelectedKrets[] }) => ({ selected: state.selectedKrets }));
  const dispatch = useDispatch();
  const select = (org: SelectedKrets[] = []): void => {
    dispatch(selectKretsAction(org));
  };

  const organizers = [].concat(props.organizers).filter((o: RemoteOrganizer) => !excludedTypes.includes(o.type));
  organizers.sort(kretsSorter);
  return (
    <div className="contextual-region block block-sidebar-first">
      <div className="block-title">
        <h3>
          <span className="disable-select">Krets</span>
        </h3>
      </div>

      <div className="block-content-outer">
        <div className="block-content">
          <Select
            isClearable
            isMulti
            onChange={select}
            value={decorateOrganizer(selected, organizers)}
            options={organizers.map((item) => ({
              label: item.name,
              value: item.id,
            }))}
            placeholder="Välj krets"
            classNamePrefix="rn"
          />
        </div>
      </div>
    </div>
  );
}
